





import React from "react";
import "./PopularRentalLocations.css";

// const locations = [
//   {
//     id: 1,
//     title: "Shirdi to Goa Cab",
//     image: "/images/keyword/33.jpg",
//     location: "Mumbai to Goa",
//     address: "Doorstep Pickup Across Mumbai & Suburbs",
//     timing: "24×7 Cab Booking",
//     timingDesc: "Flexible Pickup & Drop Time",
//     service: "One Way & Round Trip",
//     serviceDesc: "Safe & Comfortable Shirdi Darshan Travel",
//     serviceIcon: "🙏",
//     rating: "4.9",
//     wait: "10 Min",
//     support: "24×7",
//     supportLabel: "Support",
//   },

//   {
//     id: 2,
//     title: "Shirdi to Mumbai Cab",
//     image: "/images/keyword/49.jpg",
//     location: "Shirdi to Mumbai",
//     address: "Pickup From Shirdi Temple & Hotels",
//     timing: "24×7 Cab Service",
//     timingDesc: "Available Every Day Including Holidays",
//     service: "One Way & Round Trip",
//     serviceDesc: "Reliable Return Journey Service",
//     serviceIcon: "🚕",
//     rating: "4.9",
//     wait: "Fast",
//     support: "24×7",
//     supportLabel: "Booking",
//   },

//   {
//     id: 3,
//     title: "Shirdi to Grishneshwar Cab",
//     image: "/images/keyword/4.jpg",
//     location: "Shirdi to Grishneshwar",
//     address: "Pickup From Shirdi Temple & Hotels",
//     timing: "24×7 Cab Booking",
//     timingDesc: "Flexible Travel & Pickup Time",
//     service: "Temple Tour",
//     serviceDesc: "Comfortable Jyotirlinga Darshan Travel",
//     serviceIcon: "🛕",
//     rating: "4.9",
//     wait: "Fast",
//     support: "24×7",
//     supportLabel: "Support",
//   },

//   {
//     id: 4,
//     title: "Shirdi to Lonavala Cab",
//     image: "/images/keyword/6.jpg",
//     location: "Shirdi to Lonavala",
//     address: "Convenient Pickup From Shirdi",
//     timing: "Daily Cab Service",
//     timingDesc: "Flexible Pickup & Drop Time",
//     service: "Outstation Travel",
//     serviceDesc: "Safe & Comfortable Family Journey",
//     serviceIcon: "🏞️",
//     rating: "4.9",
//     wait: "Fast",
//     support: "24×7",
//     supportLabel: "Booking",
//   },

//   {
//     id: 5,
//     title: "Shirdi to Mahabaleshwar Cab",
//     image: "/images/keyword/7.jpg",
//     location: "Shirdi to Mahabaleshwar",
//     address: "Pickup From Shirdi & Nearby Hotels",
//     timing: "Daily Cab Booking",
//     timingDesc: "Flexible Travel Schedule",
//     service: "Hill Station Travel",
//     serviceDesc: "Comfortable One Way & Round Trip",
//     serviceIcon: "⛰️",
//     rating: "4.9",
//     wait: "Fast",
//     support: "24×7",
//     supportLabel: "Support",
//   },
//   {
//     id: 6,
//     title: "Shirdi to Pandharpur Cab",
//     image: "/images/keyword/29.jpg",
//     location: "Shirdi to Pandharpur",
//     address: "Pickup From Shirdi & Nearby Hotels",
//     timing: "Daily Cab Booking",
//     timingDesc: "Flexible Travel Schedule",
//     service: "Hill Station Travel",
//     serviceDesc: "Comfortable One Way & Round Trip",
//     serviceIcon: "⛰️",
//     rating: "4.9",
//     wait: "Fast",
//     support: "24×7",
//     supportLabel: "Support",
//   },
// ];


const locations = [
{
  id: 1,
  title: "Shirdi to Trimbakeshwar Cab",
  image: "/images/keyword/39.jpg",
  location: "Shirdi to Trimbakeshwar",
  address: "Doorstep Pickup From Shirdi & Nearby Hotels",
  timing: "24×7 Cab Booking",
  timingDesc: "Flexible Pickup & Drop Time",
  service: "One Way & Round Trip",
  serviceDesc: "Safe & Comfortable Journey to Trimbakeshwar",
  serviceIcon: "🛕",
  rating: "4.9",
  wait: "10 Min",
  support: "24×7",
  supportLabel: "Support",
},


  {
    id: 2,
    title: "Shirdi to Mumbai Cab",
    image: "/images/keyword/49.jpg",
    location: "Shirdi to Mumbai",
    address: "Pickup From Shirdi Temple & Hotels",
    timing: "24×7 Cab Service",
    timingDesc: "Available Every Day Including Holidays",
    service: "One Way & Round Trip",
    serviceDesc: "Reliable & Comfortable Mumbai Journey",
    serviceIcon: "🚕",
    rating: "4.9",
    wait: "Fast",
    support: "24×7",
    supportLabel: "Booking",
  },

  {
    id: 3,
    title: "Shirdi to Grishneshwar Cab",
    image: "/images/keyword/4.jpg",
    location: "Shirdi to Grishneshwar",
    address: "Pickup From Shirdi Temple & Hotels",
    timing: "24×7 Cab Booking",
    timingDesc: "Flexible Travel & Pickup Time",
    service: "Temple Tour",
    serviceDesc: "Comfortable Jyotirlinga Darshan Travel",
    serviceIcon: "🛕",
    rating: "4.9",
    wait: "Fast",
    support: "24×7",
    supportLabel: "Support",
  },

  {
    id: 4,
    title: "Shirdi to Lonavala Cab",
    image: "/images/keyword/6.jpg",
    location: "Shirdi to Lonavala",
    address: "Convenient Pickup From Shirdi",
    timing: "Daily Cab Service",
    timingDesc: "Flexible Pickup & Drop Time",
    service: "Outstation Travel",
    serviceDesc: "Safe & Comfortable Family Journey",
    serviceIcon: "🏞️",
    rating: "4.9",
    wait: "Fast",
    support: "24×7",
    supportLabel: "Booking",
  },

  {
    id: 5,
    title: "Shirdi to Mahabaleshwar Cab",
    image: "/images/keyword/7.jpg",
    location: "Shirdi to Mahabaleshwar",
    address: "Pickup From Shirdi & Nearby Hotels",
    timing: "Daily Cab Booking",
    timingDesc: "Flexible Travel Schedule",
    service: "Hill Station Travel",
    serviceDesc: "Comfortable One Way & Round Trip",
    serviceIcon: "⛰️",
    rating: "4.9",
    wait: "Fast",
    support: "24×7",
    supportLabel: "Support",
  },

  {
    id: 6,
    title: "Shirdi to Pandharpur Cab",
    image: "/images/keyword/29.jpg",
    location: "Shirdi to Pandharpur",
    address: "Pickup From Shirdi & Nearby Hotels",
    timing: "Daily Cab Booking",
    timingDesc: "Flexible Travel Schedule",
    service: "Pilgrimage Travel",
    serviceDesc: "Comfortable Temple Darshan Journey",
    serviceIcon: "🙏",
    rating: "4.9",
    wait: "Fast",
    support: "24×7",
    supportLabel: "Support",
  },
];

function PopularRentalLocations() {
  return (
    <section className="location-section p-0 pt-2 mb-3">

      <div className="container">

        {/* Heading */}
        <div className="location-heading">

          <div className="heading-decoration">

            <span></span>
            <span></span>
            <span></span>

            <h2>
              Popular Sai Shirdi Cab Services
            </h2>

            <span></span>
            <span></span>
            <span></span>

          </div>

          <p>
            Sai Shirdi Cab provides reliable taxi services from Mumbai,
            Navi Mumbai, Thane and Shirdi to popular pilgrimage,
            tourist and outstation destinations. Book comfortable
            one-way and round-trip cabs for Sai Baba Darshan,
            temple tours and long-distance journeys with professional
            drivers and affordable fares.
          </p>

        </div>

        {/* Cards */}
        <div className="location-grid">

          {locations.map((item) => (

            <div
              className="location-card"
              key={item.id}
            >

              <h3>
                {item.title}
              </h3>

              <div className="location-image">

                <img
                  src={item.image}
                  alt={item.title}
                />

              </div>

              <ul className="location-info">

                {/* Location */}
                <li>

                  <div className="info-icon">
                    📍
                  </div>

                  <div>

                    <strong>
                      {item.location}
                    </strong>

                    <p>
                      {item.address}
                    </p>

                  </div>

                </li>

                {/* Timing */}
                <li>

                  <div className="info-icon">
                    ⏰
                  </div>

                  <div>

                    <strong>
                      {item.timing}
                    </strong>

                    <p>
                      {item.timingDesc}
                    </p>

                  </div>

                </li>

                {/* Service */}
                <li>

                  <div className="info-icon">
                    {item.serviceIcon}
                  </div>

                  <div>

                    <strong>
                      {item.service}
                    </strong>

                    <p>
                      {item.serviceDesc}
                    </p>

                  </div>

                </li>

              </ul>

              {/* Bottom Information */}
              {/* <div className="location-bottom">

                <div>

                  <h4>
                    {item.rating}
                  </h4>

                  <span>
                    Rating
                  </span>

                </div>

                <div>

                  <h4>
                    {item.wait}
                  </h4>

                  <span>
                    Response
                  </span>

                </div>

                <div>

                  <h4>
                    {item.support}
                  </h4>

                  <span>
                    {item.supportLabel}
                  </span>

                </div>

              </div> */}

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}

export default PopularRentalLocations;
